// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function useTransition() {
  var match = React.useTransition();
  var startTransition = match[1];
  return [
          match[0],
          React.useMemo((function () {
                  return function (cb) {
                    startTransition(cb, undefined);
                  };
                }), [startTransition])
        ];
}

var SuspenseList = {};

export {
  useTransition ,
  SuspenseList ,
}
/* react Not a pure module */
